"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typography = exports.filtersTitle = exports.inputLabels = void 0;
var tslib_1 = require("tslib");
var styled_components_1 = require("styled-components");
exports.inputLabels = styled_components_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  font-style: normal;\n  font-weight: 600;\n  line-height: 2rem;\n"], ["\n  font-style: normal;\n  font-weight: 600;\n  line-height: 2rem;\n"])));
exports.filtersTitle = styled_components_1.css(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  font-style: normal;\n  font-weight: 700;\n  font-size: 2rem;\n  line-height: 2.8rem;\n"], ["\n  font-style: normal;\n  font-weight: 700;\n  font-size: 2rem;\n  line-height: 2.8rem;\n"])));
exports.typography = {
    type: {
        primary: '"Mulish"',
        code: '"SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace',
        docs: '"Nunito Sans", sans-serif',
        /* Mercedes-Benz */
        mbTitle: '"MB Corpo A Title Cond"',
        mbSub: '"MB Corpo S Title"',
        mbText: '"MB Corpo S Text"',
    },
    weight: {
        light: '400',
        regular: '500',
        semibold: '600',
        bold: '700',
        extrabold: '800',
        black: '900',
    },
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=typography.js.map